<template>
    <div class="login-page">
        <b-modal id="login-modal" title="Login" size="sm" centered hide-footer @show="resetModal" @hidden="resetModal" @ok="handleOk" no-stacking>
			<form ref="form" @submit.stop.prevent="handleSubmit">
                <b-form-group :state="userinfoState" label="Mobile or Email" label-for="mobile-input" invalid-feedback="Mobile or Email should be valid">
                    <b-form-input id="mobile-input" v-model="userinfo" :state="userinfoState"></b-form-input>
                </b-form-group>
                <b-form-group :state="passwordState" label="Password" label-for="password-input" invalid-feedback="Password should be greater than 4 digits">
                    <b-form-input id="password-input" v-model="password" :state="passwordState"></b-form-input>
                </b-form-group>
                <b-button type="submit" variant="primary" class="mr-2">Submit</b-button>
                <b-button type="reset" variant="light" @click="handleCancel()">Cancel</b-button>
                <p class="my-2">
                    <b-link @click="showForgetPasswordModal()">Forget Password?</b-link>
                </p>
			</form>
		</b-modal>
    </div>
</template>

<script>
export default {
    name: 'Quickview',
    data() {
        return{
            url: this.$root.WEBURL+'customerlogin',
            userinfo: '',
            password: '',
            userinfoState: null,
            passwordState: null,
        }
    },
    methods:{
        checkFormValidity() {
            var valid = true;
            if(this.userinfo.length < 10){
                valid = false;
                this.userinfoState = false;
            }else{
                this.userinfoState = true;
            }
            if(this.password.length < 4){
                valid = false;
                this.passwordState = false;
            }else{
                this.passwordState = true;
            }
            return valid;
        },
        resetModal(){
            this.userinfo = '';
            this.password = '';
            this.userinfoState = null;
            this.passwordState = null;
        },
        handleOk(bvModalEvt){
            bvModalEvt.preventDefault();
            this.handleSubmit();
        },
        handleCancel(){
            this.$bvModal.hide('login-modal');
        },
        handleSubmit(){
            if (!this.checkFormValidity()) {
                return;
            }

            var self = this;
            

            var o = {
                userinfo: this.userinfo,
                password: this.password
            }
            
			self.axios.post(self.url, o).then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvToast.toast(response.data.message, {
						title: 'Register',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'success',
						solid: true,
						appendToast: true
                    });
                    
                    self.$root.customer_info = response.data.result;
                    
                    self.$session.set('customer_info', self.$root.customer_info);


                    self.$bvModal.hide('login-modal');
				}else{
					self.error_msg = response.data.message;
				}
			})
			.catch(function (error) {
				alert(error);
			});
        },
        

        showForgetPasswordModal(){
            //this.$bvModal.hide('login-modal');
            this.$root.$emit('bv::show::modal', 'fp-modal')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">


</style>
